import Breadcrumb from '@/components/feature/Breadcrumb';
import StructuredData from '@/components/feature/StructuredData';

const aboutStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.naishuimanhua.com/' },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.naishuimanhua.com/about' },
      ],
    },
    {
      '@type': 'Organization',
      name: '奶水漫画',
      url: 'https://www.naishuimanhua.com',
      description: '奶水漫画是专注于母婴哺乳主题的原创漫画内容平台，以温馨幽默的画风呈现新手妈妈哺乳日常、母乳喂养知识与亲子互动故事',
      foundingDate: '2024',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'hello@naishuimanhua.com',
        availableLanguage: ['Chinese'],
      },
      sameAs: [
        'https://weibo.com/naishuimanhua',
        'https://www.xiaohongshu.com/user/naishuimanhua',
      ],
    },
    {
      '@type': 'AboutPage',
      name: '关于奶水漫画',
      description: '了解奶水漫画的品牌故事、团队理念、口碑评价与联系方式',
      isPartOf: { '@type': 'WebSite', name: '奶水漫画' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '奶水漫画的内容都是原创的吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，奶水漫画的内容以原创为主，由我们专业的漫画创作团队根据真实育儿经验和专业知识精心绘制。同时我们也会精选部分优质投稿作品，所有内容都经过专业审核，确保信息准确和画风一致。',
          },
        },
        {
          '@type': 'Question',
          name: '可以投稿自己的哺乳故事吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '当然可以！我们非常欢迎妈妈们投稿分享自己的哺乳故事和育儿经验。你可以通过"关于我们"页面的联系方式发送你的故事，我们的创作团队会根据投稿内容进行漫画改编。',
          },
        },
      ],
    },
  ],
};

export default function AboutPage() {
  return (
    <>
      <StructuredData data={aboutStructuredData} />
      <main className="pt-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="py-8 md:py-12">
            <div className="text-center mb-12">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                关于奶水漫画
              </h1>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
                一个用漫画记录哺乳时光、传递育儿知识、连接妈妈心声的温暖平台
              </p>
            </div>

            <div className="mb-14">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="flex-1">
                  <h2 className="text-xl font-semibold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                    品牌故事
                  </h2>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    奶水漫画诞生于2024年，由一群热爱漫画的哺乳妈妈共同创立。
                    创始人小鹿在哺乳期时发现，虽然网上有很多育儿科普文章，
                    但读起来枯燥难懂，而漫画这种形式既轻松有趣又容易理解和记忆。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    于是，她召集了几位有漫画创作背景的哺乳妈妈，一起开始了奶水漫画的创作之旅。
                    从最初在社交媒体上发布简单的四格漫画，到现在拥有完整的漫画专题页面和数万忠实读者，
                    我们始终秉持一个信念——
                    <strong className="text-foreground-900">每一位哺乳妈妈的故事都值得被温柔记录</strong>。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    我们的团队由资深漫画师、国际认证泌乳顾问（IBCLC）、育儿专家和内容编辑组成，
                    确保每一篇漫画既有趣味性又有专业性。我们希望用最温暖的方式，
                    让母乳喂养知识走进千家万户，让更多妈妈获得支持与力量。
                  </p>
                </div>
                <div className="flex-shrink-0 w-full lg:w-[340px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20cozy%20illustration%20of%20a%20team%20of%20female%20comic%20artists%20working%20together%20in%20a%20warm%20studio%2C%20drawing%20motherhood%20comics%2C%20Japanese%20manga%20art%20style%2C%20soft%20pastel%20colors%2C%20creative%20and%20collaborative%20atmosphere%2C%20plants%20and%20art%20supplies%20around&width=700&height=500&seq=about-brand-2025&orientation=landscape"
                    alt="奶水漫画创作团队"
                    title="奶水漫画 - 关于我们 品牌故事"
                    className="w-full h-auto rounded-lg"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>

            <div className="mb-14 py-10 px-4 md:px-8 rounded-lg bg-background-100 border border-background-200/60">
              <h2 className="text-xl font-semibold text-foreground-950 mb-6 text-center" style={{ fontFamily: 'var(--font-heading)' }}>
                我们的理念
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full text-xl" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                    <i className="ri-heart-line"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">温暖共情</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    我们相信每一个哺乳故事都值得被温柔对待，用漫画为妈妈们创造情感共鸣的空间
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full text-xl" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                    <i className="ri-lightbulb-line"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">专业可靠</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    所有知识类内容均由IBCLC泌乳顾问审核，确保信息的科学性和准确性
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full text-xl" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                    <i className="ri-group-line"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">妈妈互助</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    鼓励妈妈们分享自己的故事，在互助中找到力量，让哺乳之路不再孤单
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-semibold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                读者口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  {
                    name: '欣欣妈妈',
                    avatar: 'XM',
                    text: '奶水漫画陪我度过了整个哺乳期！每次堵奶焦虑的时候，翻翻漫画就能放松下来，还能学到好多实用知识。强烈推荐给所有新手妈妈！',
                    date: '2025年3月',
                  },
                  {
                    name: '小雨',
                    avatar: 'XY',
                    text: '作为一个社恐妈妈，公共场所哺乳曾经是我最害怕的事。看了"公共场所哺乳"那篇漫画后，我真的获得了很大勇气。感谢奶水漫画！',
                    date: '2025年4月',
                  },
                  {
                    name: '乐乐妈妈',
                    avatar: 'LL',
                    text: '我老公以前觉得喂奶就是妈妈的事，看了"奶爸神队友"那篇漫画后变化超大！现在主动分担好多，奶水漫画真的改变了我们家。',
                    date: '2025年5月',
                  },
                  {
                    name: '咪咪妈',
                    avatar: 'MM',
                    text: '漫画版的哺乳姿势图解太实用了！之前看了好多文字教程都看不明白，漫画一看就懂了。希望能多出这种图解类的漫画！',
                    date: '2025年6月',
                  },
                ].map((review, index) => (
                  <div
                    key={index}
                    className="p-5 rounded-lg bg-background-50 border border-background-200/60"
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full text-sm font-medium text-white" style={{ backgroundColor: 'oklch(var(--accent-500))' }}>
                        {review.avatar}
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                        <p className="text-xs text-foreground-500">{review.date}</p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      &ldquo;{review.text}&rdquo;
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="py-10 px-4 md:px-8 rounded-lg bg-background-100 border border-background-200/60">
              <h2 className="text-xl font-semibold text-foreground-950 mb-6 text-center" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto">
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full text-lg" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                    <i className="ri-mail-line"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-950 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-600">hello@naishuimanhua.com</p>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full text-lg" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                    <i className="ri-wechat-line"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-950 mb-1">微信公众号</h3>
                  <p className="text-xs text-foreground-600">搜索「奶水漫画」</p>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full text-lg" style={{ backgroundColor: 'oklch(var(--accent-100))', color: 'oklch(var(--accent-600))' }}>
                    <i className="ri-red-packet-line"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-950 mb-1">小红书</h3>
                  <p className="text-xs text-foreground-600">@奶水漫画</p>
                </div>
              </div>
              <div className="mt-8 text-center">
                <p className="text-sm text-foreground-600">
                  无论是投稿、合作还是反馈建议，都欢迎联系我们。
                  <br />
                  我们通常在24小时内回复。
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}